import { Box, BoxProps, Text } from '@chakra-ui/react';

type CostCalloutProps = {
  prefix?: string;
  amount: string;
  footer: string;
} & Pick<BoxProps, 'mt'>;

const CostCallout = ({ prefix, amount, footer, mt }: CostCalloutProps) => (
  <Box
    w="100%"
    mt={mt}
    bg="red.50"
    color="leaseEndRed"
    borderLeftWidth="3px"
    borderLeftColor="leaseEndRed"
    borderRightRadius="10px"
    px="12px"
    py="10px"
  >
    <Text fontSize={{ base: '13px', md: '14px' }} fontWeight="700">
      {prefix != null ? `You'd pay ${prefix}` : "You'd pay"}
    </Text>
    <Text
      fontSize={{ base: '23px', md: '28px' }}
      fontWeight="700"
      letterSpacing="-0.02em"
      lineHeight="1.1"
      mt="2px"
      sx={{ fontVariantNumeric: 'tabular-nums' }}
    >
      {amount}
    </Text>
    <Text fontSize={{ base: '11.5px', md: '12.5px' }} color="charcoal" mt="4px">
      {footer}
    </Text>
  </Box>
);

export default CostCallout;
